import * as Joi from 'joi';
const TableClientStateV0Schema = Joi.object({
    __typename: Joi.string(),
    showGridSummary: Joi.boolean().allow(null),
    wrapTableHeader: Joi.boolean().allow(null),
    showTableFooter: Joi.boolean().allow(null),
    ordered_column_ids: Joi.array().items(Joi.string()),
    widthState: Joi.object()
        .pattern(Joi.string(), Joi.number())
        .allow(null),
    columnProperties: Joi.object()
        .pattern(Joi.string(), Joi.object({
        wrapColumnText: Joi.boolean().allow(null),
    }))
        .allow(null),
    dataOffset: Joi.number(),
    widgetState: Joi.any(),
    column_ui_state: Joi.any(),
    column_sorting_state: Joi.any(),
});
export { TableClientStateV0Schema };
//# sourceMappingURL=v0.js.map